// @ts-nocheck
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { blue_flag, red_flag, Search_icon, view_icon } from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import { get, patch, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import moment from "moment";
import { toast } from "react-toastify";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import DateRangeMUI from "../../components/DateRange/DateRangeMUI";
import {
  customFilterOption,
  formatOptionLabel,
} from "../../components/StaticData";
import { checkPermission } from "../redux/api/PermissionManager";

// function getDatesBetween(from, to) {
//   const start = new Date(from);
//   const end = new Date(to);
//   const dates = [];

//   while (start <= end) {
//     dates.push(start.toISOString().split("T")[0]); // format YYYY-MM-DD
//     start.setDate(start.getDate() + 1);
//   }

//   return dates;
// }

// function filterBlockedDates(dateArray, blockData) {
//   // make a Set of dates where can_block is false

//   console.log("KKKKASJFASKFJKSAFJLAF<<<", dateArray, blockData);
//   const blockedFalseSet = new Set(
//     blockData &&
//       blockData
//         .filter((item) => item.can_block === false)
//         .map((item) => item.date)
//   );

//   // return only the dates not in the false set
//   return dateArray?.filter((date) => !blockedFalseSet.has(date));
// }

const OverallPropertiesList = ({ owner_id }) => {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const path = location.pathname?.replace("/", "");
  const navigate = useNavigate();
  const [page, setPage] = useState(paginationData?.[path]?.page ?? 1);
  // const [page, setPage] = useState(paginationData?.[path]?.page ?? 2);
  const [pagination, setPagination] = useState({});
  const [count, setCount] = useState(0);
  const [popup, setPopup] = useState(false);
  const [isPropertyId, setIsPropertyId] = useState();
  const [avalibleDate, setAvalibleDate] = useState(false);
  const [isKeyValue, setIsKeyValue] = useState(false);
  const [datefilter, setDateFilter] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState({
    from: paginationData?.[path]?.from ?? "",
    to: paginationData?.[path]?.to ?? "",
    city: "",
    owner: owner_id ? { value: owner_id } : "",
    search: paginationData?.[path]?.search ?? "",
  });
  const [selectedFilterAvalible, setSelectedFilterAvailable] = useState({
    from: "",
    to: "",
  });
  const [optionsList, setOptionsList] = useState({
    owners: [],
    cities: [],
  });
  const [PropertiesList, setPropertiesList] = useState([]);
  useEffect(() => {
    getOwnerList();
    getCities();
  }, []);

  useEffect(() => {
    // console.log("pagination data called", paginationData, page, pagination);
    getList(page);
    setpaginationData((prev) => ({
      ...prev,
      [path]: { ...prev?.[path], page: page, search: selectedFilter.search },
    }));
  }, [selectedFilter.city, selectedFilter.owner, selectedFilter.search, page]);

  useEffect(() => {
    const { from, to } = selectedFilter;
    if ((from && to) || (!from && !to)) getList(page);
  }, [selectedFilter.from, selectedFilter.to]);

  const getList = async (pageNumber = 1) => {
    const { city, from, owner, search, to } = selectedFilter;
    const payload = new FormData();
    payload.append("type", 4);
    if (search) {
      payload.append("search", search);
    }
    if (from && to) {
      payload.append("from_date", from);
      payload.append("to_date", to);
    }
    if (city) {
      payload.append("city", city?.value);
    }
    if (owner) {
      payload.append("owner", owner?.value);
    }
    const res = await post(
      URLS.PROPERTIES_LIST + "?page=" + pageNumber,
      payload,
    );
    console.log("overall properties", res, res?.data);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setPropertiesList(res?.data);
    }
  };
  // console.log("properties list", PropertiesList,);
  // get owners list
  const getOwnerList = async (search) => {
    console.log("search", search);
    const res = await get(
      `${URLS.OWNERS_DROPDOWN}${search ? "?search=" + search : ""}`,
    );
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name, ...item };
      });
      console.log("owner response success", res, modifiedList);
      setOptionsList((prev) => ({ ...prev, owners: modifiedList }));
    }
  };

  //cities with properties list
  const getCities = async () => {
    const res = await get(URLS.PROPERTY_CITIES);
    console.log("properties cities", res);
    if (res?.status === "success") {
      const modifiedList = res?.data?.map((item) => {
        return { value: item?.id, label: item?.name };
      });
      setOptionsList((prev) => ({ ...prev, cities: modifiedList }));
    }
  };

  const getBlockProperties = async (id) => {
    try {
      const url = `${URLS.AVAILABLE_PROPERTES_BLOCK}?property_id=${id}`;
      console.log("URLFOR BLOCK", url);
      const res = await get(url);
      if (res) {
        setAvalibleDate(res);
        setPopup(true);
      }
    } catch (err) {
      console.error("Error fetching blocks:", err);
    }
  };

  const handleStatus = async ({ id, status }) => {
    if (!checkPermission("CAN-STATUS-OVERALL_PROPERTIES")) return;
    const payload = new FormData();
    payload.append("status", status === 2 ? 3 : 2);

    const res = await patch(URLS.PROPERTY_STATUS + id + "/status/", payload);
    console.log("property status", res);
    if (res?.status === "success") {
      toast.success(res?.message);
      getList(page);
    }
  };

  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };
  const handleChangeFilterAvailable = (name, val) => {
    setSelectedFilterAvailable((prev) => ({ ...prev, [name]: val }));
  };
  const handleBlock = async (id, val) => {
    console.log("B___<<", id?.id, val);
    getBlockProperties(id?.id);
    setIsPropertyId(id?.id);
    //
  };

  // let isKeyValue;
  function checkRange(startDate, endDate) {
    console.log("startDate, endDate", startDate, endDate);
    const blockedFalseSet = new Set(
      avalibleDate?.dates
        ?.filter((item) => item.can_block === false)
        .map((item) => item.date),
    );

    const start = new Date(startDate);
    const end = new Date(endDate);
    const range = [];

    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      range.push(d.toISOString().split("T")[0]);
    }

    const blockedInRange = range.find((date) => blockedFalseSet.has(date));
    if (blockedInRange) {
      setIsKeyValue(true);
      toast.error(`Cannot select range: ${blockedInRange} is blocked!`);
      setSelectedFilterAvailable({ from: " ", to: " " });

      return false;
    }
    return range;
  }
  useEffect(() => {
    setDateFilter(
      checkRange(selectedFilterAvalible.from, selectedFilterAvalible.to),
    );
  }, [selectedFilterAvalible.from, selectedFilterAvalible.to]);

  const columns = React.useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Flag",
        accessor: "flag",
        Cell: ({ value, row }) => {
          return (
            <>
              {" "}
              {value ? (
                <img
                  src={value == "BLUE" ? blue_flag : red_flag}
                  height={"20px"}
                  width={"20px"}
                />
              ) : (
                <div></div>
              )}
            </>
          );
        },
      },
      {
        Header: " Property",
        accessor: "name",
        Cell: ({ value, row }) => {
          return (
            <div className="center text-nowrap">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.code}</p>
            </div>
          );
        },
      },
      {
        Header: "Registered date",
        accessor: "created_at",
        Cell: ({ value, row }) => {
          return <p>{moment(value).format("DD/MM/YYYY")}</p>;
        },
      },
      {
        Header: "Owner",
        accessor: "owner_name",
        Cell: ({ value, row }) => {
          return (
            <div className=" text-nowrap ">
              <p className="primary pointer">{value}</p>
              <p className="primary pointer">{row.original?.owner_code}</p>
            </div>
          );
        },
      },
      {
        Header: " Email",
        accessor: "email",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Mobile Number",
        accessor: "owner_number",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Type",
        accessor: "category_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Location",
        accessor: "area_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Requested By",
        accessor: "requested_by_type",
        Cell: ({ value, row }) => {
          return (
            <div>
              <p className="text-nowrap">{value || "Owner"}</p>
              <p className="text-nowrap">{row.original?.requested_by_code}</p>
            </div>
          );
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return value === 2 ? (
            <div className="d-flex gap-3">
              <button
                onClick={() => handleStatus(row.original)}
                className="active-btn border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
              >
                Active
              </button>

              {checkPermission("CAN-EDIT-ROOMS") && (
                <button
                  onClick={() => handleBlock(row.original)}
                  className="blockbtn border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
                >
                  Block
                </button>
              )}
            </div>
          ) : (
            <button
              onClick={() => handleStatus(row.original)}
              className="deactive-btn border-0 fs-sm-10 fs-md-12 fs-lg-14 fs-xl-13"
            >
              De-active
            </button>
          );
        },
      },
    ];
    let action = {
      Header: "Action",
      accessor: "",
      Cell: ({ value, row }) => {
        return (
          <React.Fragment>
            <div className="d-flex ac-js gap-3">
              {/* {givenpermissions?.includes("CAN-Edit-ADMINS") && ( */}
              <button
                onClick={() => {
                  navigate("/property-details", {
                    state: {
                      id: row.original?.id,
                      owner: row.original?.owner,
                      owner_name: row.original?.owner_name,
                      property_name: row.original?.name,
                      category_id: row.original?.category,
                      owner_code: row.original?.owner_code,
                    },
                  });
                  // AdminView(row.original.id, "edit");
                }}
                className="cust-btn "
              >
                <img src={view_icon} alt="" className=" edit-btn " />
              </button>
              {/* )} */}
              {/* {givenpermissions?.includes("CAN-Edit-ADMINS") && ( */}

              {/* )} */}
            </div>
          </React.Fragment>
        );
      },
    };
    return checkPermission("CAN-VIEW-OVERALL_PROPERTIES") ||
      checkPermission("CAN-EDIT-OVERALL_PROPERTIES")
      ? [...d, action]
      : d;
  }, [page]);

  console.log("selectedFilterAvalible", selectedFilterAvalible);

  const handleBlockProperites = () => {
    console.log("datefilter", datefilter);
    if (datefilter.length == 0) {
      toast.error("Kindly Choose the date ");
      return;
    }
    let value = {
      property_id: isPropertyId,
      dates: datefilter,
    };

    post(URLS.PROPERTIES_BLOCK_METHOD, value)
      .then((res) => {
        console.log("res<<____>>", res);
        if (res?.status === "success") {
          toast.success(res?.message || "Room Blocked successful");
          getList(page);
          setPopup(false);
        } else {
          toast.error(res?.error || "Something went wrong");
        }
      })
      .catch((err) => {
        toast.error("Server error. Please try again.");
        console.error("Room Blocked Error:", err);
      });
  };
  return (
    <div>
      {!owner_id && (
        <Topbar header={"Properties"} subHead={"Overall Properties"} />
      )}
      <h2 className=" f3 fs-sm-16 fs-md-20 fs-lg-22 fs-xl-24 fs-xxl-26 ">
        Total:{count}
      </h2>
      <div className="d-flex ac-je mt-3 gap-1 flex-wrap">
        <DateRange
          setFromDate={(date) => {
            handleChangeFilter("from", date);
          }}
          setToDate={(date) => {
            handleChangeFilter("to", date);
          }}
        />
        <Select
          className="location-search"
          options={optionsList?.cities}
          placeholder={"City"}
          isClearable
          onChange={(e) => {
            handleChangeFilter("city", e);
          }}
          value={selectedFilter?.city}
        />
        {!owner_id && (
          <Select
            className="location-search"
            options={optionsList?.owners}
            onChange={(e) => {
              handleChangeFilter("owner", e);
            }}
            isClearable
            value={selectedFilter?.owner}
            filterOption={customFilterOption}
            formatOptionLabel={formatOptionLabel}
            placeholder={"Owner"}
          />
        )}
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={PropertiesList}
        show={true}
      />

      {popup && (
        <div className="img-popup-design">
          <div
            className="img-popup p-0"
            style={{ maxWidth: "40%", minWidth: "27%" }}
          >
            <div className="d-flex ac-jb mb-4 p-2">
              <></>
              <CancelOutlinedIcon
                className="pointer"
                onClick={() => {
                  setPopup(false);
                }}
              />
            </div>
            <div
              className="w-100 mt-3 d-flex  ac-jc gap-4"
              style={{ flexDirection: "column" }}
            >
              {/* <DateRange
                setFromDate={(date) => {
                  handleChangeFilterAvailable("from", date);
                }}
                setToDate={(date) => {
                  handleChangeFilterAvailable("to", date);
                }}
              /> */}
              {/* <DateCalendar
                // value={selectedDate}
                onChange={(date) => handleChangeFilterAvailable("from", date)}
                shouldDisableDate={(date) =>
                  date.getDate() === blockedDate.getDate() &&
                  date.getMonth() === blockedDate.getMonth() &&
                  date.getFullYear() === blockedDate.getFullYear()
                }

                // shouldDisableDate={(date) => date.isSame(blockedDate, "day")}
              /> */}
              <DateRangeMUI
                setFromDate={(date) => {
                  handleChangeFilterAvailable("from", date);
                }}
                setToDate={(date) => {
                  handleChangeFilterAvailable("to", date);
                }}
                blockedDatesArray={avalibleDate?.dates}
                isKeyValue={isKeyValue}
                setIsKeyValue={setIsKeyValue}
              />

              <div
                className="d-flex gap-3 w-70"
                style={{
                  flexDirection: "column",
                  height: "211px",
                  overflow: "hidden",
                  // width: "70%",
                }}
              >
                <div
                  className="d-flex gap-3 w-100"
                  style={{
                    height: "288px",
                    flexDirection: "column",
                    overflow: "scroll",
                    gap: "3rem",
                  }}
                >
                  {datefilter &&
                    datefilter.map((date) => {
                      // const isActive = filteredDates.includes(date);

                      return (
                        <div
                          key={date}
                          className="d-flex items-center justify-between rounded-2xl px-4 py-3"
                          style={{
                            backgroundColor: "#faf5ff",
                            borderRadius: 15,
                            alignItems: "center",
                            gap: 10,
                            width: "100%",
                            justifyContent: "space-between",
                          }}
                        >
                          <span className="text-purple-800 font-medium">
                            {new Date(date).toLocaleDateString("en-GB")}{" "}
                          </span>
                          <div
                            className={`w-6 h-6 rounded-md ${"bg-purple-600"}`}
                            style={{
                              width: 15,
                              height: 15,
                              borderRadius: 5,
                              background: "#000",
                            }}
                          ></div>
                        </div>
                      );
                    })}
                </div>
              </div>
            </div>

            <div className="d-flex ae-jb  mt-5">
              <button
                onClick={() => handleBlockProperites()}
                className="submit-btn w-100"
              >
                Block
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
export default OverallPropertiesList;
